/**
 * The colour of the dot drawn beside a schema field's canonical data type, by
 * `canonical_data_type`: blue for numbers, green for timestamps, orange for
 * categorical, string and boolean values, and grey for containers and
 * everything else. Never the brand magenta, which marks what is active, nor
 * red, which marks an error. The canonical type's name is always drawn beside
 * the dot, so the colour is never the only cue.
 */
export const CANONICAL_TYPE_TONE: Readonly<Record<string, string>> = {
  number: "var(--blue-9)",
  number_array: "var(--blue-9)",
  latdegfloat: "var(--blue-9)",
  londegfloat: "var(--blue-9)",
  latdegint: "var(--blue-9)",
  londegint: "var(--blue-9)",
  timestamp: "var(--green-9)",
  categorical: "var(--orange-9)",
  string: "var(--orange-9)",
  boolean: "var(--orange-9)",
};

/** The dot colour for `canonicalType`: grey for any type the map does not name. */
export function canonicalTypeTone(canonicalType: string): string {
  return CANONICAL_TYPE_TONE[canonicalType] ?? "var(--gray-8)";
}
